<h1>Mot de passe perdu</h1>

<div class="py-4">
  <div>
    <div class="alert-success p-4">
      <h6>Votre demande a été traitée avec succès.</h6>
      <p>Vous recevrez dans les prochaines minutes un courriel avec les indications pour rénitialiser votre mot de
        passe.</p>
    </div>

    <button [disabled]="pending" [hidden]="status" [primary]="false" kendoButton class="w-100 mt-4"
            (click)="requestEmail()">Renvoyer le courriel
    </button>
    <button [primary]="true" kendoButton class="w-100 mt-4" routerLink="/auth/login/email" type="button">Continuer
    </button>
  </div>
</div>




// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/forgot-password/components/wait-password/wait-password.component.html